import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHitTracking } from '../../../context/hit-tracking-context';
import './Screener.scss';
import { Toast } from 'primereact/toast';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine, faCircleXmark, faPencil, faTable, faTimes } from '@fortawesome/pro-solid-svg-icons';
import CustomListModal from './saveCustomListModal';
import DropdownPicker from '../../../components/pickers/dropdownPicker';
import { DataTable } from 'primereact/datatable';
import { findIndex, set } from 'lodash';
import PeriodSelection from '../../../components/selections/periodSelection/periodSelection';
import { Column } from 'primereact/column';
import COLORS from '../../../constants/color';
import { ThemeContext } from '../../../context/theme-context';
import Search from '../../../components/search/search';
import '../../../components/dataTables/dataTable.scss';
import WatchlistAddModal from '../../../components/watchlistComponents/watchlistAddModal';
import { useNavigate } from "react-router-dom";
import BlinkerBar from '../../../components/blinker';
import { faStar } from '@fortawesome/pro-regular-svg-icons';
const Screener = () => {
    const navigate = useNavigate();
    const { trackInteraction } = useHitTracking();

    //#region Dummy Data
    const customList = [
        {
            "Id": "b18b143169cf494fa9540b2378e9ddeb",
            "Name": "Analiz 1",
            "CreateDate": "2023-11-09T00:09:04"
        },
        {
            "Id": "7b8b83d2dd7c47c699408af5668c1c85",
            "Name": "Analiz 2",
            "CreateDate": "2023-11-07T10:29:16"
        },
        {
            "Id": "c3661b85296042549a209ddece8fb83f",
            "Name": "Analiz 3",
            "CreateDate": "2023-11-09T00:09:12"
        }
    ]

    const indexListData =
        [
            {
                "Code": "XU030",
                "UniqueCode": "XU030:IS",
                "Name": "BIST 30",
                "Order": 1,
                "Popularity": 999,
                "Flag": "TR",
                "ObjectId": "git.101.72"
            },
            {
                "Code": "XU100",
                "UniqueCode": "XU100:IS",
                "Name": "BIST 100",
                "Order": 2,
                "Popularity": 1000,
                "Flag": "TR",
                "ObjectId": "git.101.74"
            },
            {
                "Code": "XU050",
                "UniqueCode": "XU050:IS",
                "Name": "BIST 50",
                "Order": 3,
                "Popularity": 998,
                "Flag": "TR",
                "ObjectId": "git.101.73"
            },
            {
                "Code": "XUMAL",
                "UniqueCode": "XUMAL:IS",
                "Name": "BIST MALİ",
                "Order": 4,
                "Popularity": 995,
                "Flag": "TR",
                "ObjectId": "git.101.77"
            },
            {
                "Code": "XUSIN",
                "UniqueCode": "XUSIN:IS",
                "Name": "BIST SINAİ",
                "Order": 5,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.78"
            },
            {
                "Code": "XUHIZ",
                "UniqueCode": "XUHIZ:IS",
                "Name": "BIST HİZMETLER",
                "Order": 6,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.75"
            },
            {
                "Code": "XUTUM",
                "UniqueCode": "XUTUM:IS",
                "Name": "BIST TÜM",
                "Order": 7,
                "Popularity": 996,
                "Flag": "TR",
                "ObjectId": "git.101.80"
            },
            {
                "Code": "XYUZO",
                "UniqueCode": "XYUZO:IS",
                "Name": "BIST 100-30",
                "Order": 8,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.83"
            },
            {
                "Code": "XTUMY",
                "UniqueCode": "XTUMY:IS",
                "Name": "BIST TÜM-100",
                "Order": 9,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.71"
            },
            {
                "Code": "XUTEK",
                "UniqueCode": "XUTEK:IS",
                "Name": "BIST TEKNOLOJİ",
                "Order": 10,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.79"
            },
            {
                "Code": "XBANK",
                "UniqueCode": "XBANK:IS",
                "Name": "BIST BANKA",
                "Order": 13,
                "Popularity": 997,
                "Flag": "TR",
                "ObjectId": "git.101.50"
            },
            {
                "Code": "XBLSM",
                "UniqueCode": "XBLSM:IS",
                "Name": "BIST BİLİŞİM",
                "Order": 14,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.51"
            },
            {
                "Code": "XELKT",
                "UniqueCode": "XELKT:IS",
                "Name": "BIST ELEKTRİK",
                "Order": 15,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.52"
            },
            {
                "Code": "XFINK",
                "UniqueCode": "XFINK:IS",
                "Name": "BIST FİN. KİR. FAKTORİNG",
                "Order": 16,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.53"
            },
            {
                "Code": "XGIDA",
                "UniqueCode": "XGIDA:IS",
                "Name": "BIST GIDA, İCECEK",
                "Order": 17,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.54"
            },
            {
                "Code": "XGMYO",
                "UniqueCode": "XGMYO:IS",
                "Name": "BIST GAYRİMENKUL Y.O.",
                "Order": 18,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.55"
            },
            {
                "Code": "XHOLD",
                "UniqueCode": "XHOLD:IS",
                "Name": "BIST HOLDİNG VE YATIRIM",
                "Order": 19,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.56"
            },
            {
                "Code": "XILTM",
                "UniqueCode": "XILTM:IS",
                "Name": "BIST İLETİŞİM",
                "Order": 20,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.58"
            },
            {
                "Code": "XKAGT",
                "UniqueCode": "XKAGT:IS",
                "Name": "BIST ORMAN, KAĞIT, BASIM",
                "Order": 21,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.59"
            },
            {
                "Code": "XKMYA",
                "UniqueCode": "XKMYA:IS",
                "Name": "BIST KİMYA,PETROL,PLASTİK",
                "Order": 22,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.60"
            },
            {
                "Code": "XKURY",
                "UniqueCode": "XKURY:IS",
                "Name": "BIST KURUMSAL YÖNETİM",
                "Order": 23,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.61"
            },
            {
                "Code": "XMANA",
                "UniqueCode": "XMANA:IS",
                "Name": "BIST METAL ANA",
                "Order": 24,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.62"
            },
            {
                "Code": "XMESY",
                "UniqueCode": "XMESY:IS",
                "Name": "BIST METAL EŞYA, MAKİNA",
                "Order": 25,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.63"
            },
            {
                "Code": "XSGRT",
                "UniqueCode": "XSGRT:IS",
                "Name": "BIST SİGORTA",
                "Order": 26,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.64"
            },
            {
                "Code": "XSPOR",
                "UniqueCode": "XSPOR:IS",
                "Name": "BIST SPOR",
                "Order": 27,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.65"
            },
            {
                "Code": "XTAST",
                "UniqueCode": "XTAST:IS",
                "Name": "BIST TAŞ, TOPRAK",
                "Order": 29,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.67"
            },
            {
                "Code": "XTCRT",
                "UniqueCode": "XTCRT:IS",
                "Name": "BIST TİCARET",
                "Order": 30,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.68"
            },
            {
                "Code": "XTEKS",
                "UniqueCode": "XTEKS:IS",
                "Name": "BIST TEKSTİL, DERİ",
                "Order": 31,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.69"
            },
            {
                "Code": "XTRZM",
                "UniqueCode": "XTRZM:IS",
                "Name": "BIST TURİZM",
                "Order": 32,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.70"
            },
            {
                "Code": "XULAS",
                "UniqueCode": "XULAS:IS",
                "Name": "BIST ULAŞTIRMA",
                "Order": 33,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.76"
            },
            {
                "Code": "XYORT",
                "UniqueCode": "XYORT:IS",
                "Name": "BIST MENKUL KIYM.Y.O.",
                "Order": 34,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.82"
            },
            {
                "Code": "XSADA",
                "UniqueCode": "XSADA:IS",
                "Name": "BIST ADANA",
                "Order": 36,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.84"
            },
            {
                "Code": "XSANK",
                "UniqueCode": "XSANK:IS",
                "Name": "BIST ANKARA",
                "Order": 37,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.85"
            },
            {
                "Code": "XSANT",
                "UniqueCode": "XSANT:IS",
                "Name": "BIST ANTALYA",
                "Order": 38,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.86"
            },
            {
                "Code": "XSBUR",
                "UniqueCode": "XSBUR:IS",
                "Name": "BIST BURSA",
                "Order": 39,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.87"
            },
            {
                "Code": "XSIST",
                "UniqueCode": "XSIST:IS",
                "Name": "BIST İSTANBUL",
                "Order": 40,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.88"
            },
            {
                "Code": "XSIZM",
                "UniqueCode": "XSIZM:IS",
                "Name": "BIST İZMİR",
                "Order": 41,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.89"
            },
            {
                "Code": "XSKAY",
                "UniqueCode": "XSKAY:IS",
                "Name": "BIST KAYSERİ",
                "Order": 42,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.90"
            },
            {
                "Code": "XSKOC",
                "UniqueCode": "XSKOC:IS",
                "Name": "BIST KOCAELİ",
                "Order": 43,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.91"
            },
            {
                "Code": "XSTKR",
                "UniqueCode": "XSTKR:IS",
                "Name": "BIST TEKİRDAĞ",
                "Order": 44,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.92"
            },
            {
                "Code": "XSBAL",
                "UniqueCode": "XSBAL:IS",
                "Name": "BIST BALIKESİR",
                "Order": 46,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.108"
            },
            {
                "Code": "XTM25",
                "UniqueCode": "XTM25:IS",
                "Name": "BIST TEMETTÜ 25",
                "Order": 47,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.109"
            },
            {
                "Code": "XTMTU",
                "UniqueCode": "XTMTU:IS",
                "Name": "BIST TEMETTÜ",
                "Order": 48,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.110"
            },
            {
                "Code": "XHARZ",
                "UniqueCode": "XHARZ:IS",
                "Name": "BIST HALKA ARZ",
                "Order": 49,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.122"
            },
            {
                "Code": "XSDNZ",
                "UniqueCode": "XSDNZ:IS",
                "Name": "BIST DENİZLİ",
                "Order": 50,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.123"
            },
            {
                "Code": "XSKON",
                "UniqueCode": "XSKON:IS",
                "Name": "BIST KONYA",
                "Order": 51,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.124"
            },
            {
                "Code": "XINSA",
                "UniqueCode": "XINSA:IS",
                "Name": "BIST İNŞAAT",
                "Order": 53,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.126"
            },
            {
                "Code": "XMADN",
                "UniqueCode": "XMADN:IS",
                "Name": "BIST MADENCİLİK",
                "Order": 54,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.127"
            },
            {
                "Code": "X030S",
                "UniqueCode": "X030S:IS",
                "Name": "BIST 30 AĞIRLIK SINIRLAMALI",
                "Order": 57,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.142"
            },
            {
                "Code": "X100S",
                "UniqueCode": "X100S:IS",
                "Name": "BIST 100 AĞIRLIK SINIRLAMALI",
                "Order": 58,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.143"
            },
            {
                "Code": "XKOBI",
                "UniqueCode": "XKOBI:IS",
                "Name": "BIST KOBİ SANAYİ",
                "Order": 59,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.144"
            },
            {
                "Code": "XUSRD",
                "UniqueCode": "XUSRD:IS",
                "Name": "BIST SÜRDÜRÜLEBİLİRLİK",
                "Order": 69,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.145"
            },
            {
                "Code": "XBANA",
                "UniqueCode": "XBANA:IS",
                "Name": "BIST ANA",
                "Order": 79,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.147"
            },
            {
                "Code": "XYLDZ",
                "UniqueCode": "XYLDZ:IS",
                "Name": "BIST YILDIZ",
                "Order": 89,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.148"
            },
            {
                "Code": "XTKJS",
                "UniqueCode": "XTKJS:IS",
                "Name": "BIST TEKNOLOJİ AĞIRLIK SINIRLAMALI",
                "Order": 175,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.175"
            },
            {
                "Code": "X10XB",
                "UniqueCode": "X10XB:IS",
                "Name": "BIST BANKA DISI LIKIT 10",
                "Order": 20002,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20002"
            },
            {
                "Code": "XAKUR",
                "UniqueCode": "XAKUR:IS",
                "Name": "BIST ARACI KURUMLAR",
                "Order": 20003,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20003"
            },
            {
                "Code": "XLBNK",
                "UniqueCode": "XLBNK:IS",
                "Name": "BIST LIKIT BANKA",
                "Order": 20004,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20004"
            },
            {
                "Code": "X030C",
                "UniqueCode": "X030C:IS",
                "Name": "BIST 30 AGIRLIK SINIRLAMALI 25",
                "Order": 20006,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20006"
            },
            {
                "Code": "X100C",
                "UniqueCode": "X100C:IS",
                "Name": "BIST 100 AGIRLIK SINIRLAMALI 25",
                "Order": 20007,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20007"
            },
            {
                "Code": "XSAYD",
                "UniqueCode": "XSAYD:IS",
                "Name": "BIST AYDIN",
                "Order": 20013,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20013"
            },
            {
                "Code": "XELOC",
                "UniqueCode": "XELOC:IS",
                "Name": "BIST 50-30 AGIRLIK SINIRLAMALI 25",
                "Order": 20014,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20014"
            },
            {
                "Code": "XELOS",
                "UniqueCode": "XELOS:IS",
                "Name": "BIST 50-30 AGIRLIK SINIRLAMALI 10",
                "Order": 20015,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20015"
            },
            {
                "Code": "XELOT",
                "UniqueCode": "XELOT:IS",
                "Name": "BIST 50-30",
                "Order": 20016,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20016"
            },
            {
                "Code": "XSMNS",
                "UniqueCode": "XSMNS:IS",
                "Name": "BIST MANISA",
                "Order": 20017,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20017"
            },
            {
                "Code": "XK030",
                "UniqueCode": "XK030:IS",
                "Name": "BIST KATILIM 30",
                "Order": 20019,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20019"
            },
            {
                "Code": "XK050",
                "UniqueCode": "XK050:IS",
                "Name": "BIST KATILIM 50",
                "Order": 20020,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20020"
            },
            {
                "Code": "XK100",
                "UniqueCode": "XK100:IS",
                "Name": "BIST KATILIM 100",
                "Order": 20021,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20021"
            },
            {
                "Code": "XKTUM",
                "UniqueCode": "XKTUM:IS",
                "Name": "BIST KATILIM TUM",
                "Order": 20022,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20022"
            },
            {
                "Code": "XSRDK",
                "UniqueCode": "XSRDK:IS",
                "Name": "BIST SURDURULEBILIRLIK KATILIM",
                "Order": 20023,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20023"
            },
            {
                "Code": "XKTMT",
                "UniqueCode": "XKTMT:IS",
                "Name": "BIST KATILIM TEMETTU",
                "Order": 20026,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20026"
            },
            {
                "Code": "XSD25",
                "UniqueCode": "XSD25:IS",
                "Name": "BIST SURDURULEBILIRLIK 25",
                "Order": 20027,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20027"
            },
            {
                "Code": "XTM25S",
                "UniqueCode": "XTM25S:IS",
                "Name": "BIST TEMETTU 25 AGIRLIK SINIRLAMALI 10",
                "Order": 20032,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20032"
            },
            {
                "Code": "XUGRA",
                "UniqueCode": "XUGRA:IS",
                "Name": "BIST GERI ALIM",
                "Order": 20033,
                "Popularity": 500,
                "Flag": "TR",
                "ObjectId": "git.101.20033"
            }
        ]

    const watchlistData = [
        {
            "Id": "00000000222200000000111111111990",
            "Name": "Favoriler",
            "CreateDate": ""
        },
        {
            "Id": "3b978f607a014a198a04513f92daac87",
            "Name": "TEST1",
            "CreateDate": "2022-09-12T10:09:13"
        },
        {
            "Id": "743ce170ef38499b93136c2d9ffcd5d7",
            "Name": "sakız2",
            "CreateDate": "2022-09-14T08:33:24"
        }
    ]

    const periodDropdownData = [
        {
            id: 1,
            name: '5 DK',
        },
        {
            id: 2,
            name: '10 DK',
        },
        {
            id: 3,
            name: '15 DK',
        },
        {
            id: 4,
            name: '15 DK',
        },
        {
            id: 5,
            name: '1 Saat',
        },
        {
            id: 6,
            name: '3 Saat',
        },
        {
            id: 7,
            name: '4 Saat',
        },
    ];

    const periodsData = ['Günlük', 'Haftalık', 'Aylık', 'Yılbaşına Göre', 'Yıllık'];

    const indicatorsData = [
        {
            indicator1: [
                {
                    "Id": "3b978f607a014a198a04513f92daac87",
                    "Name": "İndikatör Yok",
                    "CreateDate": "2022-09-12T10:09:14"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Golden Cross, Ema, D.G",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Haftalık İşlem Günü / Aylık İşlem Günü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Aşağı, Yukarı Yönlü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "50 Günlük Aşağı Keser 200 Günlük Ort.",
                    "CreateDate": "2022-09-14T08:33:25"
                },
            ],
            indicator2: [
                {
                    "Id": "3b978f607a014a198a04513f92daac87",
                    "Name": "İndikatör Yok",
                    "CreateDate": "2022-09-12T10:09:14"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Golden Cross, Ema, D.G",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Haftalık İşlem Günü / Aylık İşlem Günü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Aşağı, Yukarı Yönlü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "50 Günlük Aşağı Keser 200 Günlük Ort.",
                    "CreateDate": "2022-09-14T08:33:25"
                },
            ],
            indicator3: [
                {
                    "Id": "3b978f607a014a198a04513f92daac87",
                    "Name": "İndikatör Yok",
                    "CreateDate": "2022-09-12T10:09:14"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Golden Cross, Ema, D.G",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Haftalık İşlem Günü / Aylık İşlem Günü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Aşağı, Yukarı Yönlü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "50 Günlük Aşağı Keser 200 Günlük Ort.",
                    "CreateDate": "2022-09-14T08:33:25"
                },
            ],
            indicator4: [
                {
                    "Id": "3b978f607a014a198a04513f92daac87",
                    "Name": "İndikatör Yok",
                    "CreateDate": "2022-09-12T10:09:14"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Golden Cross, Ema, D.G",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Haftalık İşlem Günü / Aylık İşlem Günü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Aşağı, Yukarı Yönlü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "50 Günlük Aşağı Keser 200 Günlük Ort.",
                    "CreateDate": "2022-09-14T08:33:25"
                },
            ],
            indicator5: [
                {
                    "Id": "3b978f607a014a198a04513f92daac87",
                    "Name": "İndikatör Yok",
                    "CreateDate": "2022-09-12T10:09:14"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Golden Cross, Ema, D.G",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Haftalık İşlem Günü / Aylık İşlem Günü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "Aşağı, Yukarı Yönlü",
                    "CreateDate": "2022-09-14T08:33:25"
                },
                {
                    "Id": "743ce170ef38499b93136c2d9ffcd5d7",
                    "Name": "50 Günlük Aşağı Keser 200 Günlük Ort.",
                    "CreateDate": "2022-09-14T08:33:25"
                },
            ],
        }];


    const tableDataDummy = [
        { id: 0, remove: true, fav: true, search: '', tickerCode: 'FROTO', tickerName: 'EREĞLİ DEMİR ÇELİK', indicator1: "AL", indicator2: "SAT", indicator3: "AL", indicator4: "AL", indicator5: "AL", },
        { id: 1, remove: true, fav: false, search: '', tickerCode: 'TAVHL', tickerName: 'EREĞLİ DEMİR ÇELİK', indicator1: "SAT", indicator2: "SAT", indicator3: "SAT", indicator4: "SAT", indicator5: "SAT", },
        { id: 2, remove: true, fav: true, search: '', tickerCode: 'THYAO', tickerName: 'EREĞLİ DEMİR ÇELİK', indicator1: "AL", indicator2: "AL", indicator3: "AL", indicator4: "AL", indicator5: "AL", },
        { id: 3, remove: true, fav: false, search: '', tickerCode: 'TKFEN', tickerName: 'EREĞLİ DEMİR ÇELİK', indicator1: "SAT", indicator2: "SAT", indicator3: "SAT", indicator4: "SAT", indicator5: "AL", },
        { id: 4, remove: true, fav: true, search: '', tickerCode: 'TUPRS', tickerName: 'EREĞLİ DEMİR ÇELİK', indicator1: "AL", indicator2: "AL", indicator3: "AL", indicator4: "AL", indicator5: "AL", },
        { id: 5, remove: true, fav: false, search: '', tickerCode: 'CIMSA', tickerName: 'EREĞLİ DEMİR ÇELİK', indicator1: "SAT", indicator2: "SAT", indicator3: "AL", indicator4: "SAT", indicator5: "SAT", },
    ];

    //#endregion Dummy Data

    const toast = useRef(null)
    const [customListButton, setCustomListButton] = useState([]);
    const [activeCustomListButton, setActiveCustomListButton] = useState(1);
    const [indexList, setIndexList] = useState([]);
    const [selectedindex, setSelectedIndex] = useState();
    const [watchlist, setWatchlist] = useState([]);
    const [selectedWatchlist, setSelectedWatchlist] = useState();
    const [tableData, setTableData] = useState([]);
    const [periods, setPeriods] = useState([]);
    const [dropdownPeriod, setDropdownPeriod] = useState();

    const [periodDropdownPlaceHolder, setDropdownPeriodPlaceHolder] = useState('5 DK');
    const [activePeriod, setActivePeriod] = useState('Günlük');
    const [theme, setTheme] = useState("dark"); // ['dark', 'light'
    const currentTheme = useContext(ThemeContext).theme;

    const [indicator1, setIndicator1] = useState([]);
    const [selectedIndicator1, setSelectedIndicator1] = useState();

    const [indicator2, setIndicator2] = useState([]);
    const [selectedIndicator2, setSelectedIndicator2] = useState();

    const [indicator3, setIndicator3] = useState([]);
    const [selectedIndicator3, setSelectedIndicator3] = useState();

    const [indicator4, setIndicator4] = useState([]);
    const [selectedIndicator4, setSelectedIndicator4] = useState();

    const [indicator5, setIndicator5] = useState([]);
    const [selectedIndicator5, setSelectedIndicator5] = useState();

    useEffect(() => {
        setCustomListButton(customList);
        setIndexList(indexListData);
        setSelectedIndex([-1]);
        setWatchlist(watchlistData);
        setSelectedWatchlist([-1]);
        setPeriods(periodsData);
        setDropdownPeriod(periodDropdownData);
        setTheme(currentTheme);

        setIndicator1(indicatorsData[0].indicator1);
        setSelectedIndicator1(indicatorsData[0].indicator1[0]);

        setIndicator2(indicatorsData[0].indicator2);
        setSelectedIndicator2(indicatorsData[0].indicator2[0]);

        setIndicator3(indicatorsData[0].indicator3);
        setSelectedIndicator3(indicatorsData[0].indicator3[0]);

        setIndicator4(indicatorsData[0].indicator4);
        setSelectedIndicator4(indicatorsData[0].indicator4[0]);

        setIndicator5(indicatorsData[0].indicator5);
        setSelectedIndicator5(indicatorsData[0].indicator5[0]);
        // setTableData(tableDataDummy);
    }, []);

    //#region CustomListButton
    const clickCustomListButton = (id) => {
        const item = customListButton.find(b => b.Id === id);
        trackInteraction(`customList/${item?.Name || id}`);
        setActiveCustomListButton(id);
    }

    const customListButtonSave = (event) => {
        // console.log("customListButtonSave: ", event);
    }
    //#endregion CustomListButton

    //#region DropdownPicker
    const onIndexListChange = (value) => {
        setSelectedIndex(value);
    }

    const onWatchlistChange = (value) => {
        setSelectedWatchlist(value);
    }
    //#endregion DropdownPicker


    //#region PERIOD PICKER
    const clickPeriod = (period) => {

        // console.log(period);
        // activePeriod = period;
        setActivePeriod(period);
    }

    //#endregion PERIOD PICKER



    //#region DataTable Body Template

    const goTA = (event) => {
        // console.log(event);
        navigate("/technicalAnalysis/" + event.tickerCode);
    }

    const removeItem = (event) => {
        // console.log(event);
        const data = tableDataDummy.splice(event.id, 1);
        setTableData(data);
    }


    const headerTemplate = (indicatorItem) => {
        if (indicatorItem == 'indicator1') {
            return (
                <div className=" align-items-center" data-testid='indicator1div'>
                    <DropdownPicker testId='indicator1-list' className='' data-testid='indicator1' listData={indicator1} selectedListItem={selectedIndicator1} onListItemChange={(event) => onIndicatorPickerChange(event, 'indicator1')} optionLabel='Name' icon={true} />
                </div>

            );
        }
        else if (indicatorItem == 'indicator2') {
            return (
                <div className=" align-items-center">
                    <DropdownPicker testId='indicator2-list' className='' listData={indicator2} selectedListItem={selectedIndicator2} onListItemChange={(event) => onIndicatorPickerChange(event, 'indicator2')} optionLabel='Name' icon={true} />
                </div>
            );
        }
        else if (indicatorItem == 'indicator3') {
            return (
                <div className=" align-items-center ">
                    <DropdownPicker testId='indicator3-list' className='' listData={indicator3} selectedListItem={selectedIndicator3} onListItemChange={(event) => onIndicatorPickerChange(event, 'indicator3')} optionLabel='Name' icon={true} />
                </div>
            );
        }

        else if (indicatorItem == 'indicator4') {
            return (
                <div className=" align-items-center">
                    <DropdownPicker testId='indicator4ƒ-list' className='' listData={indicator4} selectedListItem={selectedIndicator4} onListItemChange={(event) => onIndicatorPickerChange(event, 'indicator4')} optionLabel='Name' icon={true} />
                </div>
            );
        }

        else if (indicatorItem == 'indicator5') {
            return (
                <div className=" align-items-center">
                    <DropdownPicker testId='indicator5-list' className='' listData={indicator5} selectedListItem={selectedIndicator5} onListItemChange={(event) => onIndicatorPickerChange(event, 'indicator5')} optionLabel='Name' icon={true} />
                </div>
            );
        }

        else if (indicatorItem == 'search') {
            return (
                <div className="flex align-items-center">
                    <Search />
                </div>
            );
        }
    }

    const bodyTemplate = (event, item) => {


        if (item == 'RemoveIcon') {
            return (
                <div className="remove-item" onClick={() => removeItem(event)}>
                    <FontAwesomeIcon className='icon' icon={faCircleXmark} />
                </div>
            );
        }
        else if (item == 'favIcon') {
            //GB Kaldırdı Screener sayfası aktif eidlince ekleyeceğim 
            return (
                <></>
            )
        }

        else if (item == 'technicalAnalysis') {
            return (
                <div className='technicalAnalysis-body'>
                    <FontAwesomeIcon className='technicalAnalysisIcon' icon={faChartLine} onClick={() => goTA(event)} />
                </div>
            )
        }

        else if (item.includes('indicator')) {
            const indicator = item;

            if (event[indicator] == 'AL') {
                return (
                    <div className=" align-items-center">
                        <label className='indicatorLabel green roboto-medium-14'>
                            {event[item]}
                        </label>
                    </div>
                )
            }

            else if (event[indicator] == 'SAT') {
                return (
                    <div className=" align-items-center">
                        <label className='indicatorLabel red roboto-medium-14'>
                            {event[item]}
                        </label>
                    </div>
                )
            }
        }

    }

    const onIndicatorPickerChange = (value, periodItem) => {
        trackInteraction(`indicator/${periodItem}/${value?.Name || value}`);
        if (periodItem == 'indicator1') {
            setTableData(tableDataDummy);
            return setSelectedIndicator1(value);
        }
        else if (periodItem == 'indicator2') {
            setTableData(tableDataDummy);

            return setSelectedIndicator2(value);
        }
        else if (periodItem == 'indicator3') {
            return setSelectedIndicator3(value);
        }
        else if (periodItem == 'indicator4') {
            return setSelectedIndicator4(value);
        }
        else if (periodItem == 'indicator5') {
            return setSelectedIndicator5(value);
        }
    }
    //#endregion DataTable Body Template
    // const cellClassName = (data) => (data.indicator1 == 'SAT' ? 'realTimeRedBg' : data.indicator2 == 'SAT' ? 'realTimeRedBg' : 'realTimeGreenBg');

    return (
        <div className="sreener-page">

            <Toast ref={toast} position='bottom-right' />
            {/* Custom List Buttons */}

            <div className='edit-buttons-row'>
                {
                    customListButton.map((item, index) =>
                        <div
                            key={item.Id}
                            className={`custom-list-buttons button roboto-bold-14 ${activeCustomListButton === item.Id ? 'active' : ''}`}
                            onClick={() => clickCustomListButton(item.Id)}>
                            <div className='inside-button'>
                                <FontAwesomeIcon className='icon' icon={faPencil} />
                            </div>
                            {item.Name}
                        </div>
                    )
                }
                <CustomListModal customListButtonSave={customListButtonSave} />
            </div>

            {/* Custom List Buttons */}

            {/* Dropdown Items */}
            <Container className='m-t-20 m-b-10 p-0 transition'>
                <Row>
                    <Col lg='3' className='dropdown-col-2 ' >
                        <DropdownPicker testId='screener-index-list' className='' listData={indexList} optionLabel='Name' selectedListItem={selectedindex} onListItemChange={onIndexListChange} icon={true} placeholder='Endeks Seçiniz' />
                    </Col>

                    <Col lg='1' className='text-col p-0 m-t-auto m-b-auto picker-between-text'>
                        <label className='text roboto-regular-16 p-0  color-text transition'>
                            veya
                        </label>
                    </Col>

                    <Col lg='3' className='dropdown-col-2' >
                        <DropdownPicker testId='watchlist-index-list' className='' listData={watchlist} optionLabel='Name' selectedListItem={selectedWatchlist} onListItemChange={onWatchlistChange} icon={true} placeholder='İzlediklerim Listesi Seçiniz' />
                    </Col>

                    <Col className='dropdown-col-2'>
                        <div>
                            <PeriodSelection periods={periods} dropdownPeriod={dropdownPeriod} dropdownSelectedPeriodIndex={""} dropdownPeriodPlaceHolder={periodDropdownPlaceHolder} dropdownOptionLabel='name' activePeriod={activePeriod} clickPeriod={clickPeriod} />
                        </div>

                    </Col>

                </Row>
            </Container>
            {/* Dropdown Items */}


            < DataTable key='id' value={tableData}
                dataKey="id" scrollable scrollHeight="700px"
                style={{ minWidth: '100%', minHeight: '700px', }}
                tableStyle={{ minWidth: '100%', display: 'grid' }}
                emptyMessage="Birden fazla hisse senedi görmek için hisse seçiminizi yapın.">

                <Column field="" headerStyle={{ width: '0rem', display: 'none' }} header="" bodyStyle={{ width: '1rem', fontFamily: 'Roboto-Regular', paddingRight: '0' }} body={(event) => bodyTemplate(event, 'RemoveIcon')} />
                <Column field="" headerStyle={{ width: '0rem', display: 'none' }} header="" bodyStyle={{ width: '1rem', fontFamily: 'Roboto-Regular', paddingRight: '0' }} body={(event) => bodyTemplate(event, 'favIcon')} />

                <Column field="" headerStyle={{ width: '50rem', }} header={headerTemplate('search')} bodyStyle={{ display: 'none', fontFamily: 'Roboto-Regular' }} />

                <Column field="tickerCode" headerStyle={{ width: '0rem', display: 'none' }} header='' bodyStyle={{ width: '4rem', fontFamily: 'Roboto-Bold', fontSize: '14px', paddingRight: '0' }} />
                <Column field="technicalAnalysis" headerStyle={{ width: '0rem', display: 'none' }} header="" bodyStyle={{ textAlign: 'left', width: '9rem', }} body={(event) => bodyTemplate(event, 'technicalAnalysis')} />
                <Column field="indicator1" headerStyle={{ width: '15rem' }} header={headerTemplate('indicator1')} bodyStyle={{ width: '15rem', textAlign: 'center' }} body={(event) => bodyTemplate(event, 'indicator1')} />
                <Column field="indicator2" headerStyle={{ width: '15rem' }} header={headerTemplate('indicator2')} bodyStyle={{ width: '15rem', textAlign: 'center' }} body={(event) => bodyTemplate(event, 'indicator2')} />
                <Column field="indicator3" headerStyle={{ width: '15rem' }} header={headerTemplate('indicator3')} bodyStyle={{ width: '15rem', textAlign: 'center' }} body={(event) => bodyTemplate(event, 'indicator3')} />
                <Column field="indicator5" headerStyle={{ width: '15rem' }} header={headerTemplate('indicator5')} bodyStyle={{ width: '15rem', textAlign: 'center' }} body={(event) => bodyTemplate(event, 'indicator4')} />
                <Column field="indicator4" headerStyle={{ width: '15rem' }} header={headerTemplate('indicator4')} bodyStyle={{ width: '15rem', textAlign: 'center' }} body={(event) => bodyTemplate(event, 'indicator5')} />

            </DataTable>

        </div >
    )
}

export default Screener;